import debugLib from 'debug';
import moment from 'moment';
import * as R from 'ramda';
import { GET_SESSION_EVENTS, LOAD_EVENTS, SESSION_CREATE, SESSION_UPDATE } from '../actions/PbaLiveviewActions';
import { reducerWrapper } from '../support/utils';
import type { PbaLiveviewActionPayload, PbaLiveviewReducer } from '../types/pbaLiveviewTypes';

const debug = debugLib('PbaLiveviewReducer');

export const INIT_STATE: PbaLiveviewReducer = {
  loading: true,
  error: null,
  events: [],
  queue: [],
  filter: '',
  event_datasource: [],
  is_new_pipe: false,
  throttled: false,
  session_id: null,
};

function isThrottled(last_throttle) {
  const POLL_FREQUENCY_MIN = 5;
  return last_throttle && moment().diff(moment(last_throttle), 'minutes') <= POLL_FREQUENCY_MIN;
}

function isNewPipe(pipe_created: number) {
  const PIPE_CREATION_THRESHOLD_MIN = 2;
  return moment().diff(moment(pipe_created), 'minutes') <= PIPE_CREATION_THRESHOLD_MIN;
}

function Handler(state: PbaLiveviewReducer, action: PbaLiveviewActionPayload) {
  const { data, type } = action;

  switch (type) {
    case SESSION_CREATE.response:
      debug(action);
      return Object.assign({}, state, {
        loading: false,
        error: null,
        events: data.events,
        queue: [],
        event_datasource: data.event_datasource,
        is_new_pipe: isNewPipe(data.created),
        filter: data.filter,
        session_id: data.session_id,
      });

    case SESSION_UPDATE.response:
      debug(action);
      return Object.assign({}, state, {
        loading: false,
        error: null,
        events: data.events,
        queue: [],
        event_datasource: data.event_datasource,
        is_new_pipe: isNewPipe(data.created),
        filter: data.filter,
        throttled: false,
        // we want to reset throttling on update to session
        session_id: data.session_id,
      });

    case GET_SESSION_EVENTS.response:
      debug(action);
      const throttled = state.throttled || isThrottled(data.last_throttle);
      const queue = data?.events?.filter((event) => {
        return !R.contains(event, state.events);
      });
      return Object.assign({}, state, {
        queue,
        throttled,
        is_new_pipe: isNewPipe(data.created),
      });

    case LOAD_EVENTS:
      debug(action);
      return Object.assign({}, state, {
        events: [...state.queue, ...state.events],
        queue: [],
      });

    default:
      return state;
  }
}

const WebhooksReducer = reducerWrapper(INIT_STATE, Handler, {
  request: [SESSION_CREATE, SESSION_UPDATE],
  error: [SESSION_CREATE, SESSION_UPDATE, GET_SESSION_EVENTS],
  resetOn: ['APP_CHANGE'],
});
export default WebhooksReducer;
